/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Delete_EventInputs */

const en_shortcut_keys_desc_delete_event = /** @type {(inputs: Shortcut_Keys_Desc_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete selected event(s)`)
};

const fr_shortcut_keys_desc_delete_event = /** @type {(inputs: Shortcut_Keys_Desc_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le(s) evenement(s) selectionne(s)`)
};

const de_shortcut_keys_desc_delete_event = /** @type {(inputs: Shortcut_Keys_Desc_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewähltes(e) Ereignis(se) löschen`)
};

const it_shortcut_keys_desc_delete_event = /** @type {(inputs: Shortcut_Keys_Desc_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina gli eventi selezionati`)
};

const ru_shortcut_keys_desc_delete_event = /** @type {(inputs: Shortcut_Keys_Desc_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить выбранное событие(я)`)
};

const es_shortcut_keys_desc_delete_event = /** @type {(inputs: Shortcut_Keys_Desc_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar eventos seleccionados`)
};

const zh_cn2_shortcut_keys_desc_delete_event = /** @type {(inputs: Shortcut_Keys_Desc_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除选定事件`)
};

const ja_shortcut_keys_desc_delete_event = /** @type {(inputs: Shortcut_Keys_Desc_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントを削除`)
};

const hi_shortcut_keys_desc_delete_event = /** @type {(inputs: Shortcut_Keys_Desc_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित इवेंट्स को डिलीट करें`)
};

const pt_pt2_shortcut_keys_desc_delete_event = /** @type {(inputs: Shortcut_Keys_Desc_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir evento(s) selecionado(s)`)
};

/**
* | output |
* | --- |
* | "Delete selected event(s)" |
*
* @param {Shortcut_Keys_Desc_Delete_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_delete_event = /** @type {((inputs?: Shortcut_Keys_Desc_Delete_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Delete_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_delete_event(inputs)
	if (locale === "de") return de_shortcut_keys_desc_delete_event(inputs)
	if (locale === "it") return it_shortcut_keys_desc_delete_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_delete_event(inputs)
	if (locale === "es") return es_shortcut_keys_desc_delete_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_delete_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_delete_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_delete_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_delete_event(inputs)
	return en_shortcut_keys_desc_delete_event(inputs)
});